define(["data/config"], function(config) {

    var apply = function($element, params) {
        let checkboxes = $element.find('input[type=checkbox]');
        let buyButton = $element.find('button[type=submit]');


        checkboxes.change(function () {
            if (checkboxes.filter(':checked').length < 1) {
                buyButton.prop('disabled', true);
                buyButton.addClass('c_uiButton--disabled');
            } else {
                buyButton.prop('disabled', false);
                buyButton.removeClass('c_uiButton--disabled');
            }
        });
        checkboxes.change();
    };

    return {
        name: "upgradesForm",
        apply: apply
    };
});

